import { render } from "./ResDetail.vue?vue&type=template&id=23ed91b4"
import script from "./ResDetail.vue?vue&type=script&lang=js"
export * from "./ResDetail.vue?vue&type=script&lang=js"

import "./ResDetail.vue?vue&type=style&index=0&id=23ed91b4&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1d9c808fc766473613eb0f9d559345b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__